import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const showSubmenu = (elem, overlay) => {
  stopElemAnim(elem);
  stopElemAnim(overlay);

  showElem(elem);
  showElem(overlay);
};

const hideSubmenu = (elem, overlay) => {
  addCloseElemAnim(overlay);
  addCloseElemAnim(elem);

  timeout.id = setTimeout(() => {
    hideElem(elem);
    hideElem(overlay);
  }, 300);
};

export const initSubmenu = () => {
  const overlay = document.querySelector('.overlay');
  const submenuItems = document.querySelectorAll('.nav-submenu-item');

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu');

    submenuItem.addEventListener('mouseenter', (e) => {
      submenuItem.classList.add('open');
      clearTimeout(timeout.id);
      showSubmenu(submenu, overlay);
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      // Don't close if moving to a submenu item or category menu (they're all within the submenu)
      if (e.relatedTarget && submenu.contains(e.relatedTarget)) {
        return;
      }
      submenuItem.classList.remove('open');
      hideElem(e.target.querySelector('.submenu'));
      hideSubmenu(submenu, overlay);
    });

    submenuItem.addEventListener('keydown', (e) => {
      const submenuBtn = e.currentTarget.querySelector('button');
      const keyCode = e.code;

      if (keyCode === 'Space' || keyCode === 'Enter') {
        clearTimeout(timeout.id);
        if (submenuBtn.getAttribute('aria-expanded') === 'true') {
          hideSubmenu(submenu, overlay);

          submenuBtn.setAttribute('aria-expanded', 'false');
        } else {
          showSubmenu(submenu, overlay);

          submenuBtn.setAttribute('aria-expanded', 'true');
        }
      }
    });

    submenuItem.addEventListener('focusout', (e) => {
      const currentTargetLastClass = '.' + e.currentTarget.classList[1];
      const submenuBtn = e.currentTarget.querySelector('button');

      if (!e.relatedTarget.closest(currentTargetLastClass)) {
        hideSubmenu(submenu, overlay);

        submenuBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // Handle submenu items with category-menu children
    const allSubmenuItems = submenu.querySelectorAll('.submenu__item');
    
    allSubmenuItems.forEach((item) => {
      const categoryMenu = item.querySelector('.category-menu');
      
      // Only add handlers if this item has a category-menu
      if (categoryMenu) {
        item.addEventListener('mouseenter', () => {
          // Keep the parent submenu open
          submenuItem.classList.add('open');
          clearTimeout(timeout.id);
          showSubmenu(submenu, overlay);
          // Show the category menu
          showElem(categoryMenu);
        });

        item.addEventListener('mouseleave', (e) => {
          // Only hide if not moving to the category menu
          if (!e.relatedTarget || !categoryMenu.contains(e.relatedTarget)) {
            hideElem(categoryMenu);
          }
        });
      }
    });

    // Handle category-menu hover to keep submenu open
    const categoryMenus = submenu.querySelectorAll('.category-menu');
    
    categoryMenus.forEach((categoryMenu) => {
      categoryMenu.addEventListener('mouseenter', () => {
        // Keep the parent submenu open
        submenuItem.classList.add('open');
        clearTimeout(timeout.id);
        showSubmenu(submenu, overlay);
        showElem(categoryMenu);
      });

      categoryMenu.addEventListener('mouseleave', (e) => {
        // Only hide if not moving back to the submenu item
        const parentSubmenuItem = categoryMenu.closest('.submenu__item');
        if (!e.relatedTarget || !parentSubmenuItem.contains(e.relatedTarget)) {
          hideElem(categoryMenu);
        }
      });
    });
  });
};
